import BackupIcon from "@mui/icons-material/Backup";
import { Card, CardContent, CardHeader, CircularProgress, Stack } from "@mui/material";
import { useCallback, useState, Dispatch } from "react";
import { Button, Create, required, SimpleForm, TextInput, useDataProvider, useNotify } from "react-admin";
import { FieldValues } from "react-hook-form";
import { fetchSiteRecord } from "./queries";
import CreateIcon from "@mui/icons-material/Create";
import { SitesBaseForm } from "../shared/components/SitesBaseForm";

const ManualCreateForm = () => {
  const [displayForm, setdisplayForm] = useState(false);
  const [defaultValues, setDefaultValues] = useState<Record<string, unknown>>({});

  return (
    <Create>
      {displayForm ? (
        <SitesBaseForm defaultValues={defaultValues} />
      ) : (
        <Stack direction="row" spacing={2} sx={{ width: "100%", p: 2 }}>
          <FillFromAirtableCard setDefaultValues={setDefaultValues} setdisplayForm={setdisplayForm} />
          <ContinueManuallyCard setdisplayForm={setdisplayForm} />
        </Stack>
      )}
    </Create>
  );
};
export default ManualCreateForm;

type FillFromAirtableCardProps = {
  setDefaultValues: Dispatch<React.SetStateAction<Record<string, unknown>>>;
  setdisplayForm: Dispatch<React.SetStateAction<boolean>>;
};

const FillFromAirtableCard = ({ setDefaultValues, setdisplayForm }: FillFromAirtableCardProps) => {
  const [loading, setloading] = useState(false);
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const handleConfirm = useCallback(
    async ({ record_asset_id }: FieldValues) => {
      setloading(true);
      try {
        const siteData = await fetchSiteRecord(dataProvider, record_asset_id);
        setDefaultValues(siteData);
        setdisplayForm(true);
      } catch (error: any) {
        notify(`Error ${error?.status} - ${error?.response?.data?.detail}`, { type: "error" });
        console.error(error);
      } finally {
        setloading(false);
      }
    },
    [dataProvider, notify, setDefaultValues, setdisplayForm],
  );
  return (
    <Card sx={{ width: "50%" }} variant="outlined">
      <CardHeader
        title="Prefill from Airtable"
        subheader="Enter the Asset ID of the site you want to prefill, the corresponding site data will be fetched from airtable"
      />
      <CardContent>
        <SimpleForm
          onSubmit={handleConfirm}
          toolbar={
            <Button
              label="Prefill"
              type="submit"
              size="large"
              variant="contained"
              fullWidth
              startIcon={loading ? <CircularProgress color="secondary" size={20} /> : <BackupIcon />}
              disabled={loading}
            />
          }
        >
          <TextInput fullWidth source="record_asset_id" label="Asset ID" validate={required()} />
        </SimpleForm>
      </CardContent>
    </Card>
  );
};

type ContinueManuallyCardProps = {
  setdisplayForm: Dispatch<React.SetStateAction<boolean>>;
};

const ContinueManuallyCard = ({ setdisplayForm }: ContinueManuallyCardProps) => {
  return (
    <Card sx={{ width: "50%" }} variant="outlined">
      <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <Button
          label="Continue Manually"
          onClick={() => {
            setdisplayForm(true);
          }}
          size="large"
          variant="contained"
          startIcon={<CreateIcon />}
        />
      </CardContent>
    </Card>
  );
};
